import { useTranslation } from 'react-i18next'
import type { StockStatus } from '../../types'

interface StockBadgeProps {
  status: StockStatus
}

const STATUS_STYLE: Record<StockStatus, { dotClass: string; textClass: string; bgClass: string }> = {
  in_stock:     { dotClass: 'bg-green-500',   textClass: 'text-green-700',  bgClass: 'bg-green-50' },
  low_stock:    { dotClass: 'bg-yellow-500',  textClass: 'text-yellow-700', bgClass: 'bg-yellow-50' },
  out_of_stock: { dotClass: 'bg-red-500',     textClass: 'text-red-700',    bgClass: 'bg-red-50' },
  on_order:     { dotClass: 'bg-purple-500',  textClass: 'text-purple-700', bgClass: 'bg-purple-50' },
  unknown:      { dotClass: 'bg-neutral-300', textClass: 'text-neutral-700', bgClass: 'bg-gcg-tint' },
}

export default function StockBadge({ status }: StockBadgeProps) {
  const { t } = useTranslation()
  // WEB-392 / DEC-022: there is no per-product stock feed yet, so every product
  // is 'unknown'. The owner wants no stock badge in that case — render nothing
  // rather than a hedged "available" claim. Real states stay supported for when
  // an inventory feed (Exact/ELIS) exists.
  if (status === 'unknown') return null
  const style = STATUS_STYLE[status] ?? STATUS_STYLE.unknown
  const label = t(`shop.stock.${status}`, { defaultValue: t('shop.stock.unknown') })
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${style.bgClass} ${style.textClass}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${style.dotClass}`} />
      {label}
    </span>
  )
}
